import axios from 'axios';
import api from '../config/api';

// Travelpayouts public datasets for metadata
const CITIES_URL = 'https://api.travelpayouts.com/data/en/cities.json';

// Token handled server-side; no direct use here

let iataToContinentCache = null;
let iataMetaCache = null;

const buildIataToContinent = async () => {
  if (iataToContinentCache) return iataToContinentCache;

  const citiesRes = await axios.get(CITIES_URL);

  // Comprehensive country code to continent mapping
  const countryCodeToContinent = {
    // Africa
    'ZA': 'AF', 'EG': 'AF', 'KE': 'AF', 'MA': 'AF', 'NG': 'AF', 'GH': 'AF', 'TZ': 'AF', 'UG': 'AF', 'ET': 'AF', 'DZ': 'AF',
    'TN': 'AF', 'LY': 'AF', 'SD': 'AF', 'SS': 'AF', 'TD': 'AF', 'NE': 'AF', 'ML': 'AF', 'BF': 'AF', 'CI': 'AF', 'LR': 'AF',
    'SL': 'AF', 'GN': 'AF', 'GW': 'AF', 'GM': 'AF', 'SN': 'AF', 'MR': 'AF', 'CV': 'AF', 'ST': 'AF', 'GQ': 'AF', 'GA': 'AF',
    'CG': 'AF', 'CD': 'AF', 'AO': 'AF', 'ZM': 'AF', 'ZW': 'AF', 'BW': 'AF', 'NA': 'AF', 'SZ': 'AF', 'LS': 'AF', 'MG': 'AF',
    'MU': 'AF', 'SC': 'AF', 'KM': 'AF', 'DJ': 'AF', 'SO': 'AF', 'ER': 'AF', 'BI': 'AF', 'RW': 'AF', 'MW': 'AF', 'MZ': 'AF',
    // Asia  
    'CN': 'AS', 'JP': 'AS', 'KR': 'AS', 'IN': 'AS', 'TH': 'AS', 'SG': 'AS', 'MY': 'AS', 'ID': 'AS', 'PH': 'AS', 'VN': 'AS',
    'TW': 'AS', 'HK': 'AS', 'BD': 'AS', 'PK': 'AS', 'LK': 'AS', 'MM': 'AS', 'KH': 'AS', 'LA': 'AS', 'MN': 'AS', 'NP': 'AS',
    'BT': 'AS', 'AF': 'AS', 'IR': 'AS', 'IQ': 'AS', 'SY': 'AS', 'LB': 'AS', 'JO': 'AS', 'IL': 'AS', 'PS': 'AS', 'SA': 'AS',
    'AE': 'AS', 'QA': 'AS', 'BH': 'AS', 'KW': 'AS', 'OM': 'AS', 'YE': 'AS', 'KZ': 'AS', 'UZ': 'AS', 'TM': 'AS', 'TJ': 'AS',
    'KG': 'AS', 'GE': 'AS', 'AM': 'AS', 'AZ': 'AS', 'TR': 'AS', 'CY': 'AS', 'BN': 'AS', 'TL': 'AS', 'MV': 'AS',
    // Europe
    'GB': 'EU', 'FR': 'EU', 'DE': 'EU', 'IT': 'EU', 'ES': 'EU', 'NL': 'EU', 'BE': 'EU', 'CH': 'EU', 'AT': 'EU', 'SE': 'EU',
    'NO': 'EU', 'DK': 'EU', 'FI': 'EU', 'PL': 'EU', 'CZ': 'EU', 'HU': 'EU', 'RO': 'EU', 'BG': 'EU', 'HR': 'EU', 'GR': 'EU',
    'PT': 'EU', 'IE': 'EU', 'IS': 'EU', 'LU': 'EU', 'MT': 'EU', 'EE': 'EU', 'LV': 'EU', 'LT': 'EU', 'SK': 'EU', 'SI': 'EU',
    'AL': 'EU', 'MK': 'EU', 'RS': 'EU', 'ME': 'EU', 'BA': 'EU', 'XK': 'EU', 'MD': 'EU', 'UA': 'EU', 'BY': 'EU', 'RU': 'EU',
    // North America
    'US': 'NA', 'CA': 'NA', 'MX': 'NA', 'GT': 'NA', 'BZ': 'NA', 'SV': 'NA', 'HN': 'NA', 'NI': 'NA', 'CR': 'NA', 'PA': 'NA',
    'CU': 'NA', 'JM': 'NA', 'HT': 'NA', 'DO': 'NA', 'PR': 'NA', 'TT': 'NA', 'BB': 'NA', 'AG': 'NA', 'KN': 'NA', 'LC': 'NA',
    'VC': 'NA', 'GD': 'NA', 'BS': 'NA', 'DM': 'NA', 'AI': 'NA', 'VG': 'NA', 'VI': 'NA', 'KY': 'NA', 'TC': 'NA', 'AW': 'NA',
    // South America
    'BR': 'SA', 'AR': 'SA', 'CL': 'SA', 'PE': 'SA', 'CO': 'SA', 'VE': 'SA', 'EC': 'SA', 'BO': 'SA', 'PY': 'SA', 'UY': 'SA',
    'GY': 'SA', 'SR': 'SA', 'FK': 'SA', 'GF': 'SA',
    // Oceania
    'AU': 'OC', 'NZ': 'OC', 'FJ': 'OC', 'PG': 'OC', 'NC': 'OC', 'VU': 'OC', 'SB': 'OC', 'TO': 'OC', 'WS': 'OC', 'KI': 'OC',
    'TV': 'OC', 'NR': 'OC', 'PW': 'OC', 'FM': 'OC', 'MH': 'OC', 'MP': 'OC', 'GU': 'OC', 'AS': 'OC', 'CK': 'OC', 'NU': 'OC',
    'TK': 'OC', 'WF': 'OC', 'PF': 'OC', 'PN': 'OC', 'NF': 'OC', 'AQ': 'OC', 'HM': 'OC', 'BV': 'OC', 'GS': 'OC', 'TF': 'OC'
  };

  const map = {};
  const meta = {};
  citiesRes.data.forEach((city) => {
    if (!city.code) return;
    
    // Get continent from country code mapping
    let continent = countryCodeToContinent[city.country_code];
    
    if (!continent) {
      // Fallback: try to infer from city name patterns
      const cityName = (city.name_translations?.en || city.name || '').toLowerCase();
      if (cityName.includes('tokyo') || cityName.includes('seoul') || cityName.includes('bangkok') || cityName.includes('singapore')) {
        continent = 'AS';
      } else if (cityName.includes('london') || cityName.includes('paris') || cityName.includes('rome') || cityName.includes('madrid')) {
        continent = 'EU';
      } else if (cityName.includes('new york') || cityName.includes('los angeles') || cityName.includes('toronto') || cityName.includes('mexico')) {
        continent = 'NA';
      } else if (cityName.includes('sydney') || cityName.includes('melbourne') || cityName.includes('auckland')) {
        continent = 'OC';
      } else if (cityName.includes('cairo') || cityName.includes('nairobi') || cityName.includes('cape town')) {
        continent = 'AF';
      } else if (cityName.includes('rio') || cityName.includes('buenos aires') || cityName.includes('lima')) {
        continent = 'SA';
      }
    }
    
    // Final fallback
    if (!continent) continent = 'OTHER';
    
    const name = city.name_translations?.en || city.name || city.code;
    // Travelpayouts cities include coordinates { lon, lat }
    const lat = city.coordinates?.lat ?? city.lat;
    const lon = city.coordinates?.lon ?? city.lon;
    map[city.code] = { continent, country_code: city.country_code, name };
    meta[city.code] = { name, country_code: city.country_code, latitude: lat, longitude: lon };
  });

  iataToContinentCache = map;
  iataMetaCache = meta;
  return map;
};

export const getContinentForIata = async (iata) => {
  const map = await buildIataToContinent();
  return map[iata]?.continent || 'OTHER';
};

export const getIataMeta = async (iata) => {
  if (!iataMetaCache) await buildIataToContinent();
  return iataMetaCache?.[iata] || null;
};

// Cheapest prices to destinations from origin (no destination => many)
export const getCheapPricesFromOrigin = async (origin, currency = 'usd', passengers = 1) => {
  // use backend proxy via configured API client (already prefixed with /api)
  const url = `/deals/cheap?origin=${encodeURIComponent(origin)}&currency=${currency}&passengers=${passengers}`;
  const { data } = await api.get(url);
  return data?.data || {};
};

export const getWeekMatrix = async (origin, destination, departDate, returnDate, currency = 'usd', passengers = 1) => {
  const url = `/deals/week-matrix?currency=${currency}&origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(destination)}&depart_date=${encodeURIComponent(departDate)}&return_date=${encodeURIComponent(returnDate)}&passengers=${passengers}`;
  const { data } = await api.get(url);
  return data?.data || [];
};

// Utility to transform the cheap prices response into an array with continent info
export const groupDealsByContinent = async (cheapPricesData) => {
  console.log('🗺️ groupDealsByContinent called with:', cheapPricesData);
  
  // cheapPricesData is a map: destinationIATA -> { <date_key>: { price, ... } } OR { price, ... }
  const map = await buildIataToContinent();
  console.log('🌍 IATA to continent map built, sample entries:', Object.entries(map).slice(0, 5));
  
  // Log continent distribution
  const continentCounts = {};
  Object.values(map).forEach(({ continent }) => {
    continentCounts[continent] = (continentCounts[continent] || 0) + 1;
  });
  console.log('🌍 Continent distribution in map:', continentCounts);
  
  const deals = [];
  Object.keys(cheapPricesData).forEach((dest) => {
    const value = cheapPricesData[dest];
    console.log(`🔍 Processing destination ${dest}:`, value);
    
    // The API sometimes nests by airline/date. Normalize: take the cheapest price found.
    let min = null;
    if (value && typeof value === 'object') {
      Object.values(value).forEach((v) => {
        if (v && typeof v === 'object' && typeof v.price === 'number') {
          if (min === null || v.price < min.price) min = v;
        }
      });
    }
    if (min) {
      const meta = map[dest] || { continent: 'OTHER', name: dest };
      console.log(`✅ Found deal for ${dest}: continent=${meta.continent}, country_code=${meta.country_code}, name=${meta.name}, price=${min.price}`);
      deals.push({ destination: dest, destinationName: meta.name, continent: meta.continent, price: min.price, found_at: min.found_at, gate: min.gate, depart_date: min.depart_date, return_date: min.return_date });
    } else {
      console.log(`❌ No valid price found for ${dest}`);
    }
  });

  console.log('📊 All deals found:', deals);

  const grouped = deals.reduce((acc, d) => {
    acc[d.continent] = acc[d.continent] || [];
    acc[d.continent].push(d);
    return acc;
  }, {});

  console.log('🗺️ Grouped by continent:', grouped);

  // sort each continent by price and pick top 5
  Object.keys(grouped).forEach((k) => {
    grouped[k].sort((a, b) => a.price - b.price);
    grouped[k] = grouped[k].slice(0, 5);
  });

  console.log('📈 Final grouped result:', grouped);
  return grouped;
};


